import FormatCurrency from 'src/app/utils/format-currency-utils';
import { effect, inject, Injectable, signal } from '@angular/core';
import { AssetStore } from 'src/app/stores/asset.store';

@Injectable({
  providedIn: 'root',
})
export class FormatPriceUtils {
  private formatCurrency = inject(FormatCurrency);
  private assetStore = inject(AssetStore);

  public isCommaDecimal = signal(
    this.formatCurrency.isCommaDecimal(Intl.DateTimeFormat().resolvedOptions().locale || navigator.language),
  );

  constructor() {
    effect(
      () => {
        this.updateCommaDecimal();
      },
      { allowSignalWrites: true },
    );
  }

  public updateCommaDecimal() {
    const userLanguage = navigator.language;
    this.isCommaDecimal.set(
      this.formatCurrency.isCommaDecimal(Intl.DateTimeFormat().resolvedOptions().locale || userLanguage),
    );
  }

  formatPrice(value: string | number, assetTicker: string) {
    let valueToString = value?.toString();

    if (!this.isCommaDecimal()) {
      value = parseFloat(valueToString?.replaceAll(',', ''));
    } else {
      if (valueToString?.includes('.') && Number.isNaN(Number(value))) {
        valueToString = valueToString?.replaceAll('.', '');
      }
      value = parseFloat(valueToString?.replace(',', '.'));
    }

    const decimal = assetTicker === 'noDecimalPlaces' ? 0 : this.assetStore.decimalPlacesFor()[assetTicker || 'USD'];

    const formatter = new Intl.NumberFormat(this.isCommaDecimal() ? 'pt-BR' : 'en-US', {
      maximumFractionDigits: decimal,
      minimumFractionDigits: decimal,
    });

    const finalValue = formatter.format(value).trim();

    return finalValue === 'NaN' ? '0' : finalValue;
  }
}
